/**
 * OfflineBanner — the offline pattern (KICKOFF item 7 / §3.4): slim top banner,
 * steel with an amber accent (status orange token — gold is earned-only law),
 * "You're offline — plays are queued." plus the queued-write count. Slides
 * in/out on the panel move (.28s settle). Stays mounted for the slide-out and
 * is pointer-events:none — it never blocks the action strip.
 */
export interface OfflineBannerProps {
  /** Whether the banner is shown. Keep mounted and toggle for the slide. */
  visible: boolean;
  /** Number of queued offline writes (shown when > 0). */
  queuedCount?: number;
  /** Default: "You're offline — plays are queued." */
  message?: string;
  className?: string;
}

export function OfflineBanner({
  visible,
  queuedCount = 0,
  message = "You're offline — plays are queued.",
  className,
}: OfflineBannerProps) {
  return (
    <div
      className={["mdui-offline", className].filter(Boolean).join(" ")}
      data-state={visible ? "open" : "closed"}
      role="status"
      aria-live="polite"
      {...(visible ? {} : { "aria-hidden": true })}
    >
      <span className="mdui-offline-dot" aria-hidden="true" />
      <span className="mdui-offline-copy">{message}</span>
      {queuedCount > 0 ? (
        <span className="mdui-offline-count">{queuedCount}</span>
      ) : null}
    </div>
  );
}
